import { render, staticRenderFns } from "./ConteudoVisualFormPage.vue?vue&type=template&id=8ba09db8&scoped=true"
import script from "./ConteudoVisualFormPage.vue?vue&type=script&lang=js"
export * from "./ConteudoVisualFormPage.vue?vue&type=script&lang=js"
import style0 from "./ConteudoVisualFormPage.vue?vue&type=style&index=0&id=8ba09db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba09db8",
  null
  
)

export default component.exports